
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { list_type, record_type, bool_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { tryFind, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export class DashboardBlock extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TrackerMap", "OpenNotifications", "RunningStocktakings", "InspectionStatus", "ProblemReports", "InMaintenance", "Reminders", "Availability", "ToolReturnDates", "MinimumStock", "NextReservations", "ReleaseDates"];
    }
}

export function DashboardBlock_$reflection() {
    return union_type("Shared.DashboardConfiguration.DashboardBlock", [], DashboardBlock, () => [[], [], [], [], [], [], [], [], [], [], [], []]);
}

export const DashboardBlockModule_all = ofArray([new DashboardBlock(0, []), new DashboardBlock(1, []), new DashboardBlock(2, []), new DashboardBlock(3, []), new DashboardBlock(4, []), new DashboardBlock(5, []), new DashboardBlock(6, []), new DashboardBlock(7, []), new DashboardBlock(8, []), new DashboardBlock(9, []), new DashboardBlock(10, []), new DashboardBlock(11, [])]);

export function DashboardBlockModule_key(block) {
    switch (block.tag) {
        case 1:
            return "open_notifications";
        case 2:
            return "running_stocktakings";
        case 3:
            return "inspection_status";
        case 4:
            return "problem_reports";
        case 5:
            return "in_maintenance";
        case 6:
            return "reminders";
        case 7:
            return "availability";
        case 8:
            return "tool_return_dates";
        case 9:
            return "minimum_stock";
        case 10:
            return "next_reservations";
        case 11:
            return "release_dates";
        default:
            return "tracker_map";
    }
}

export function DashboardBlockModule_ofKey(value) {
    return tryFind((block) => (DashboardBlockModule_key(block) === value), DashboardBlockModule_all);
}

export class DashboardBlockSize extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Small", "Medium", "Large"];
    }
}

export function DashboardBlockSize_$reflection() {
    return union_type("Shared.DashboardConfiguration.DashboardBlockSize", [], DashboardBlockSize, () => [[], [], []]);
}

export const DashboardBlockSizeModule_all = ofArray([new DashboardBlockSize(0, []), new DashboardBlockSize(1, []), new DashboardBlockSize(2, [])]);

export function DashboardBlockSizeModule_key(size) {
    switch (size.tag) {
        case 1:
            return "medium";
        case 2:
            return "large";
        default:
            return "small";
    }
}

export function DashboardBlockSizeModule_ofKey(value) {
    return tryFind((size) => (DashboardBlockSizeModule_key(size) === value), DashboardBlockSizeModule_all);
}

export class DashboardBlockConfiguration extends Record {
    constructor(Block, Size, Visible) {
        super();
        this.Block = Block;
        this.Size = Size;
        this.Visible = Visible;
    }
}

export function DashboardBlockConfiguration_$reflection() {
    return record_type("Shared.DashboardConfiguration.DashboardBlockConfiguration", [], DashboardBlockConfiguration, () => [["Block", DashboardBlock_$reflection()], ["Size", DashboardBlockSize_$reflection()], ["Visible", bool_type]]);
}

export class DashboardConfigurationDto extends Record {
    constructor(Blocks, IsCustomized) {
        super();
        this.Blocks = Blocks;
        this.IsCustomized = IsCustomized;
    }
}

export function DashboardConfigurationDto_$reflection() {
    return record_type("Shared.DashboardConfiguration.DashboardConfigurationDto", [], DashboardConfigurationDto, () => [["Blocks", list_type(DashboardBlockConfiguration_$reflection())], ["IsCustomized", bool_type]]);
}

export class UpdateDashboardConfigurationDto extends Record {
    constructor(Blocks) {
        super();
        this.Blocks = Blocks;
    }
}

export function UpdateDashboardConfigurationDto_$reflection() {
    return record_type("Shared.DashboardConfiguration.UpdateDashboardConfigurationDto", [], UpdateDashboardConfigurationDto, () => [["Blocks", list_type(DashboardBlockConfiguration_$reflection())]]);
}

